import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalesReportComponent } from './sales-report/sales-report.component';

const reportsRoutes: Routes = [
  { path: 'reports/:cnpj/sales', component: SalesReportComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(reportsRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ReportsRoutingModule { }
